<template>
    <div>
        <h4>Add A Role</h4>
        <UserPersonaSelect :role.sync="roleToAdd" @addedRole="updateUser" />
        <v-button aria-hidden="true" tabindex="2" @click="_addRole">
            <fa-icon :icon="['fas', 'user-plus']" /> Add Role
        </v-button>
        <hr>

        <!-- TODO: Could probably do this in one template with a v-for -->
        <template v-if="formattedUserPersonae.institutions.length > 0">
            <h4 class="mt-3">
                {{ activeRealm === 'statestartup' ? 'Applicant' : 'Institution' }}
                Roles
            </h4>
            <b-container class="pt-3">
                <UserPersonaList
                    :personae="formattedUserPersonae.institutions"
                    @deleteConfirmed="_removeRole($event)"
                />
            </b-container>
        </template>

        <template v-if="formattedUserPersonae.staff.length > 0">
            <h4 class="mt-3">
                Staff Roles
            </h4>
            <b-container class="pt-3">
                <UserPersonaList
                    :personae="formattedUserPersonae.staff"
                    @deleteConfirmed="_removeRole($event)"
                />
            </b-container>
        </template>
    </div>
</template>

<script>
import { mapGetters, mapState, mapActions } from 'vuex';
import UserPersonaSelect from './UserPersonaSelect';
import UserPersonaList from './UserPersonaList';

export default {
    components: {
        UserPersonaSelect,
        UserPersonaList,
    },

    props: {
        userId: { type: Number, required: true },
    },

    data() {
        return {
            user: {
                user_id: null,
                persona: null,
                personae: [],
            },
            roleToAdd: null,
            staffRoleIds: ['PR', 'PA', 'AM', 'BM', 'ADMIN', 'SUP'],
        };
    },

    computed: {
        ...mapGetters({
            activeRealm: 'auth/activeRealm',
            activeRole: 'auth/activeRole',
        }),

        ...mapState('auth', {
            adminUser: 'user',
        }),

        editingOwnRoles() {
            return this.adminUser.user_id === this.userId;
        },

        editablePersonae() {
            if (this.activeRole !== 'SU') {
                return this.user.personae.filter(
                    (persona) => persona.role_id !== 'SU' && persona.realm_id === this.activeRealm
                );
            }

            return this.user.personae;
        },

        formattedUserPersonae() {
            let formattedPersonae = {
                institutions: [],
                staff: [],
            };

            this.editablePersonae.forEach((persona) => {
                let category = 'institutions';
                if (this.staffRoleIds.includes(persona.role_id)) {
                    category = 'staff';
                }

                formattedPersonae[category].push({
                    title: persona.title,
                    id: persona.persona_id,
                    role_id: persona.role_id,
                });
            });

            return formattedPersonae;
        },
    },

    created() {
        this.updateUser();
    },

    methods: {
        ...mapActions({
            removeRole: 'auth/removeRole',
            addRole: 'auth/addRole',
            // updateUser: 'auth/getUserInfo'
            getUserInfo: 'auth/getUserInfo'
        }),

        async _removeRole(roleId) {
            await this.removeRole({ userId: this.userId, personaId: roleId });

            this.updateUser();
        },

        async _addRole() {
            await this.addRole({
                userId: this.user.user_id || this.userId,
                ...this.roleToAdd,
            });

            this.updateUser();
        },

        async updateUser() {
            this.user = await this.getUserInfo(this.userId);
            return this.user;
        },
    },
};
</script>
